// Currency / country selector — submits the localization form whenever the
// shopper picks a different country, so the page reloads with prices shown
// in that market's currency (Shopify Markets converts the numbers; this file
// only has to trigger the reload).
document.addEventListener('DOMContentLoaded', function () {
var selects = document.querySelectorAll('[data-currency-selector]');
selects.forEach(function (select) {
select.addEventListener('change', function () {
var form = select.closest('form');
if (form) form.submit();
});
});
});